var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasNotification)?_c('div',{staticClass:"notification-container"},[_c('button',{staticClass:"iconButton",on:{"click":function($event){return _vm.clearNotification($event)}}},[_c('BaseIcon',{attrs:{"name":"x-square"}})],1),_c('h4',[_vm._v(_vm._s(_vm.NotificationStore.notification))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }